import React, { useEffect } from 'react';
import './ProductandSol.css';

const ProductandSol = () => {
    useEffect(() => {
        console.log('ProductandSol useEffect running');
        const elements = document.querySelectorAll('.animate-on-scroll');
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    console.log(`${entry.target.className} isIntersecting: ${entry.isIntersecting}`);
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate');
                    }
                });
            },
            { threshold: 0.2 }
        );

        elements.forEach((element) => {
            console.log('Observing:', element);
            observer.observe(element);
        });

        return () => {
            elements.forEach((element) => observer.unobserve(element));
        };
    }, []);

    const keyTopics = [
        {
            title: "Solution Ideation Process",
            description: "Brainstorming innovative solutions to address IoT and embedded system challenges."
        },
        {
            title: "Requirements Definition Process",
            description: "Defining precise requirements for integrated IoT product and solution development."
        },
        {
            title: "Integrated System Design Process",
            description: "Designing cohesive systems combining hardware, software, and connectivity for IoT."
        },
        {
            title: "Hardware-Software Integration Process",
            description: "Ensuring seamless integration of hardware and software for reliable IoT solutions."
        },
        {
            title: "Cloud and Connectivity Solutions Process",
            description: "Developing cloud-based and connectivity solutions for real-time IoT data management."
        },
        {
            title: "User Interface Development Process",
            description: "Creating intuitive interfaces for user interaction with IoT and embedded systems."
        },
        {
            title: "Solution Testing Process",
            description: "Conducting comprehensive tests to validate solution performance and reliability."
        },
        {
            title: "Deployment and Scaling Process",
            description: "Deploying and scaling IoT solutions for widespread adoption and performance."
        },
        {
            title: "Support and Optimization Process",
            description: "Providing ongoing support and optimization for sustained IoT solution efficiency."
        }
    ];

    return (
        <div className="detail-page">
            <h1 className="detail-heading animate-on-scroll" style={{ animationDelay: '0.1s' }}>
                Product and Solution Development
            </h1>
            <p className="detail-intro animate-on-scroll" style={{ animationDelay: '0.2s' }}>
                Our product and solution development services deliver integrated, reliable, and innovative solutions for IoT and embedded systems, from ideation to deployment and support.
            </p>
            <h2 className="detail-subheading animate-on-scroll" style={{ animationDelay: '0.3s' }}>
                Key Topics
            </h2>
            <ul className="detail-topics">
                {keyTopics.map((topic, index) => (
                    <li
                        key={index}
                        className="topic-card animate-on-scroll"
                        style={{ animationDelay: `${0.4 + index * 0.05}s` }}
                    >
                        <strong className="topic-title">{topic.title}</strong>
                        <p className="topic-description">{topic.description}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default ProductandSol;